import { styled } from '@linaria/react';

import { Text } from '~components/Typography';
import { gradientText } from '~theme/snippets';

export const SForm = styled.form`
	display: flex;
	max-width: 100%;
	flex-flow: column nowrap;
	align-items: center;
	justify-content: center;
	gap: var(--gap-l);
`;

export const SDiscount = styled(Text)`
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	display: flex;
	flex: 0;
	align-items: center;
	align-self: center;
	padding-right: 16px;
	font-size: inherit;
	font-variant-numeric: tabular-nums;
	font-weight: inherit;
	gap: var(--gap-m);
	line-height: inherit;
	text-align: right;
	text-transform: inherit;
	white-space: nowrap;
	@media screen and (max-width: 360px) {
		font-size: 0;
		span {
			font-size: var(--font-size-l);
			line-height: var(--line-height-headline-s);
		}
	}

	span {
		padding-left: 2px;
		${gradientText};
	}
`;

export const SInput = styled.input`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	min-width: 156px;
	height: 100%;
	padding: var(--padding);
	border: none;
	appearance: none;
	background: none;
	box-shadow: none;
	font-size: inherit;
	font-weight: inherit;
	letter-spacing: 3px;
	line-height: inherit;
	outline: none;
	text-align: center;
	text-transform: inherit;
	&[disabled] {
		opacity: 1;
	}
`;

export const SInputOuter = styled.div`
	--discount-padding: 110px;
	position: relative;
	display: flex;
	min-width: 156px;
	max-width: 100%;
	flex-flow: row nowrap;
	align-items: center;
	justify-content: center;
	border-radius: var(--border-r);
	background-color: var(--color-white-m);
	font-size: var(--font-size-xl);
	font-weight: var(--font-weight-semibold);
	line-height: 100%;
	text-transform: uppercase;
	&::after {
		padding: var(--padding);
		content: attr(data-value) ' ';
		font-size: inherit;
		font-weight: inherit;
		letter-spacing: 3px;
		line-height: inherit;
		text-transform: inherit;
		visibility: hidden;
		white-space: pre;
	}
	&:has(${SDiscount}) {
		padding-right: var(--discount-padding);
		@media screen and (max-width: 360px) {
			font-size: var(--font-size-l);
			--discount-padding: 75px;
		}
		${SInput} {
			padding-right: var(--discount-padding);
		}
	}
`;

export const SInfoText = styled(Text)<{ hasError: boolean; isActive: boolean }>`
	min-height: 18px;
	color: ${({ hasError, isActive }) =>
		hasError
			? 'var(--color-error)'
			: isActive
			? 'var(--color-white-solid)'
			: 'var(--color-grey-68-solid)'};
	cursor: ${({ isActive }) => (isActive ? 'pointer' : 'default')};
	font-weight: ${({ isActive }) =>
		isActive ? 'var(--font-weight-semibold)' : 'var(--font-weight-normal)'};
	text-decoration: ${({ isActive }) => (isActive ? 'underline' : 'none')};
	user-select: none;
`;
